import { FC } from 'react';

import CopyableField from 'dashboard/components/CopyableField';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface RotateRecoveryCodeModalProps {
  recoveryCode: string | undefined;
  onClose: () => void;
}

const RotateRecoveryCodeModal: FC<RotateRecoveryCodeModalProps> = ({ recoveryCode, onClose }) => {
  return (
    <ModalContainer>
      <ModalHeader onClose={onClose}>Write down your recovery code</ModalHeader>

      <ModalBody>
        <Paragraph>
          Your recovery code will let you access your account if you lose access to your 2-factor
          device.
        </Paragraph>
        <Spacer height={2} />
        <Paragraph>
          <strong>This code will only be displayed once.</strong>
        </Paragraph>
        <Spacer height={2} />
        {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
        <CopyableField value={recoveryCode} data-test='rotate-recovery-code-modal__code' />
      </ModalBody>
    </ModalContainer>
  );
};

export default RotateRecoveryCodeModal;
